import axios from 'axios';

import {
  completeCheckoutResponseSchema,
  cryptoPublicKeySchema,
  initCheckoutResponseSchema,
  pixQrCodeResponseSchema,
  type completeCheckoutResponse,
  type CryptoPublicKey,
  type initCheckoutResponse,
  type PaymentRequest,
  type PaymentSearch,
  type PixQrCodeResponse,
} from '@/features/checkout/payment.schema';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { httpPostAdapter } from '@/lib/adapters/httpPostAdapter';

export type InitCheckoutRequest = Required<Pick<PaymentSearch, 'pacoteId'>> & Pick<PaymentSearch, 'cupom'>;

export const initCheckout = httpPostAdapter<initCheckoutResponse, InitCheckoutRequest>({
  url: '/v3/venda/pagamento/inicia',
  schema: initCheckoutResponseSchema,
  mapBody: (payload) => ({
    pacoteId: payload.pacoteId,
    ...(payload.cupom ? { cupom: payload.cupom } : {}),
  }),
});

export const completeCheckout = httpPostAdapter<completeCheckoutResponse, PaymentRequest>({
  url: '/v3/venda/pagamento/finaliza',
  schema: completeCheckoutResponseSchema,
  mapBody: (payload) => payload,
});

// Busca a chave pública do CognaPay para criptografar os dados do cartão (RSA).
// Host distinto do backend, então não usa a instância `api` (cookie/interceptors de auth).
export async function getCryptoPublicKey(): Promise<CryptoPublicKey> {
  const baseUrl = import.meta.env.VITE_COGNAPAY_URL;
  if (!baseUrl) throw new Error('VITE_COGNAPAY_URL não configurada.');

  const res = await axios.get<unknown>(`${baseUrl}/api/Cryptography/GetPublicKeyAsync`);
  return cryptoPublicKeySchema.parse(res.data);
}

export const getPixQrCode = httpGetAdapter<PixQrCodeResponse, number>({
  url: '/v3/venda/pagamento/pix',
  schema: pixQrCodeResponseSchema,
  mapParams: (transacaoId) => ({ transacaoId }),
});
